export const MODE_FALLBACK_ORDER = {
    1: [2, 3],    // Desktop falls back to: Tablet, then Mobile
    2: [1, 3],    // Tablet falls back to: Desktop, then Mobile
    3: [2, 1]     // Mobile falls back to: Tablet, then Desktop
  } as const;
  
  export type ResponsiveMode = 1 | 2 | 3;